import ActivityFamilyLine from './ActivityFamilyLine'
export default ActivityFamilyLine
